import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { PageHero } from "@/components/common/Bits";
import { useLanguage } from "@/context/LanguageContext";
import { api, fileUrl } from "@/lib/api";

const defaultsForSlug = (slug, t) => {
  const map = {
    "ekonomi-ticaret": { title: t.act_economy, desc: t.act_economy_desc, image: "https://customer-assets-39nsmqrw.emergentagent.net/job_useko-web/artifacts/j9z65wix_5-Sanayi%2C%20Teknoloji%2C%20Savunma%2C%20Ekonomi%20ve%20Ticaret.png" },
    "sanayi-teknoloji-savunma": { title: t.act_industry, desc: t.act_industry_desc, image: "https://customer-assets-39nsmqrw.emergentagent.net/job_useko-web/artifacts/flomohzc_WhatsApp%20Image%202026-07-27%20at%2023.39.42.jpeg" },
    "egitim-akademik": { title: t.act_education, desc: t.act_education_desc, image: "https://customer-assets-39nsmqrw.emergentagent.net/job_useko-web/artifacts/q6znwdt4_7-E%C4%9Fitim%20ve%20Akademi.png" },
    "sosyal-kalkinma": { title: t.act_social, desc: t.act_social_desc, image: "https://customer-assets-39nsmqrw.emergentagent.net/job_useko-web/artifacts/mrp9990g_6-Sosyal%20Kalk%C4%B1nma.png" },
    "kulturel-diplomasi": { title: t.act_culture, desc: t.act_culture_desc, image: "https://customer-assets-39nsmqrw.emergentagent.net/job_useko-web/artifacts/hyqydrt6_8-K%C3%BClt%C3%BCrel%20Diplomasi.png" },
    "arastirma-yayin": { title: t.act_research, desc: t.act_research_desc, image: "https://customer-assets-39nsmqrw.emergentagent.net/job_useko-web/artifacts/y918k6tq_9-Ara%C5%9Ft%C4%B1rma%20ve%20Yay%C4%B1nc%C4%B1l%C4%B1k.png" },
    "mali-ticari": { title: t.act_financial, desc: t.act_financial_desc, image: "https://customer-assets-39nsmqrw.emergentagent.net/job_useko-web/artifacts/wajqpgpw_10-Mali%20ve%20Ticari%20Faaliyetler.png" },
  };
  return map[slug];
};

export default function ActivityAreaPage() {
  const { slug } = useParams();
  const { t } = useLanguage();
  const [area, setArea] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setArea(null); setNotFound(false);
    api.get(`/activity-areas/${slug}?_=${Date.now()}`)
      .then(r => setArea(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  const fallback = defaultsForSlug(slug, t);
  if (notFound && !fallback) {
    return (
      <div className="useko-container py-32 text-center" data-testid="activity-not-found">
        <h1 className="font-heading text-3xl font-bold text-[#102A43]">{t.not_found_title}</h1>
        <Link to="/" className="btn-primary mt-6 inline-flex">{t.back_to_home}</Link>
      </div>
    );
  }

  const title = area?.title || fallback?.title || "";
  const description = t.focus_areas_body;
  const image = area?.image ? fileUrl(area.image) : (fallback?.image || "");
  const contentHtml = area?.content_html || "";
  const buttonLabel = area?.button_label || "İletişim";
  const bullets = (t.act_bullets && t.act_bullets[slug]) || [];

  return (
    <div data-testid={`activity-area-${slug}`}>
      <PageHero title={title} description={description} image={image}/>
      <section className="py-20 useko-container grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7">
          <div className="prose-useko rich-content overflow-hidden">
            {contentHtml
              ? <div dangerouslySetInnerHTML={{ __html: contentHtml }}/>
              : (
                <>
                  <h2>{t.heading_focus_areas}</h2>
                  {bullets.length > 0 && (
                    <ul>{bullets.map((b, i) => <li key={i}>{b}</li>)}</ul>
                  )}
                </>
              )
            }
          </div>
          <div className="mt-10">
            <h2 className="font-heading text-2xl font-bold text-[#0B1837] mb-2">{t.area_contact_heading}</h2>
            <p className="text-[#4B5563] text-base leading-relaxed mb-5">{t.area_contact_body}</p>
            {/* Non-clickable gold button — admin sets label (e.g. contact email) */}
            <span
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-br from-[#E8C577] via-[#D4A94F] to-[#B8862F] text-[#051436] font-bold text-sm cursor-default select-text"
              data-testid={`area-cta-${slug}`}
            >
              {buttonLabel}
            </span>
          </div>
        </div>
        {image && (
          <aside className="lg:col-span-5">
            <div className="aspect-[4/5] rounded-3xl overflow-hidden bg-[#051436] flex items-center justify-center">
              <img src={image} alt={title} className="w-full h-full object-cover"/>
            </div>
          </aside>
        )}
      </section>
    </div>
  );
}
